import { put, select, takeLatest } from 'redux-saga/effects';
import { SAGA_ACTIONS } from 'modules/Taps/redux/ndfl3Saga/NDFL3SagaActionTypes';
import {
  startRequest as getTaxes,
  requestSuccess as getTaxesSuccess,
} from 'modules/NewTaxes/redux/taxes/actions';
import { selectNDFL3ReturnSum } from 'modules/Taps/components/NDFL3/selectors';

export default function* overpaymentDisposalSaga() {
  yield takeLatest(SAGA_ACTIONS.INITIALIZE_OVERPAYMENTS_DISPOSAL, initSaga);
}

function* initSaga() {
  const returnSum = yield select(selectNDFL3ReturnSum);

  if (returnSum) {
    yield put(getTaxes());
  } else {
    yield put(getTaxesSuccess([]));
  }
}
